import { render, staticRenderFns } from "./VmSearch.vue?vue&type=template&id=663c6b12&scoped=true&"
import script from "./VmSearch.vue?vue&type=script&lang=js&"
export * from "./VmSearch.vue?vue&type=script&lang=js&"
import style0 from "./VmSearch.vue?vue&type=style&index=0&id=663c6b12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663c6b12",
  null
  
)

export default component.exports